import { StyledCalendarTools } from "Bands/pages/calendar/styles";
import { Button } from "shared/components";
import { CheckboxButton } from "shared/components/Button/CheckboxButton";
import { Spacer } from "shared/layout";
import { ITheme } from "shared/types";

import {
  CalendarListTable,
  CalendarPicker,
  TodayAction,
} from "Bands/pages/calendar/containers";
import { useAtomValue } from "jotai";
import { copy } from "shared/assets";
import { visibleRowsAtom } from "shared/components/Table/table-atoms";

interface Props {
  setStep: (step: 1 | 2 | 3) => void;
  handleModalClose: () => void;
  handleCheckboxChange: (value: string) => void;
  selectedEvents: string[];
  setSelectedEvents: React.Dispatch<React.SetStateAction<string[]>>;
}

export const PushCopyStep2 = ({
  setStep,
  handleModalClose,
  handleCheckboxChange,
  selectedEvents,
  setSelectedEvents,
}: Props) => {
  const visibleRows = useAtomValue(visibleRowsAtom);

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedEvents((prev: string[]) => {
        return Array.from(new Set([...prev, ...visibleRows]));
      });
    } else {
      setSelectedEvents((prev: string[]) => {
        return prev.filter((id) => !visibleRows.includes(id));
      });
    }
  };

  return (
    <Spacer size="l">
      <StyledCalendarTools>
        <Spacer
          spaceDirection="horizontal"
          size="m"
          style={{ width: "100%", justifyContent: "space-between" }}
        >
          <Spacer spaceDirection="horizontal" size="l">
            <CalendarPicker />
            <TodayAction />
          </Spacer>
          {visibleRows.length > 0 && (
            <CheckboxButton
              label="Select all events"
              checked={
                visibleRows.length > 0 &&
                visibleRows.every((row) => selectedEvents?.includes(row))
              }
              onChange={(e) => handleSelectAll(e.target.checked)}
              style={{
                alignSelf: "flex-end",
              }}
            />
          )}
        </Spacer>
      </StyledCalendarTools>

      <CalendarListTable
        hideHeader
        showCheckboxes
        hideCurrentEvent
        handleCheckboxChange={handleCheckboxChange}
        selectedEvents={selectedEvents}
        hideBirthdays
      />
      <Spacer size="s" spaceDirection="horizontal">
        <Button
          type="button"
          size="l"
          theme={ITheme.primary}
          onClick={() => {
            setStep(3);
          }}
          disabled={selectedEvents.length === 0}
        >
          {selectedEvents.length === 0
            ? copy.pushCopyBlock.step2.selectAtLeastOneEvent
            : `${copy.pushCopyBlock.step2.copyTo} ${
                selectedEvents.length
              } event${selectedEvents.length > 1 ? "s" : ""}`}
        </Button>
        <Button
          type="button"
          size="l"
          theme={ITheme.secondary}
          onClick={handleModalClose}
        >
          {copy.pushCopyBlock.step2.cancel}
        </Button>
      </Spacer>
    </Spacer>
  );
};
